import { googlePlace } from '../../../models';

import { getApis } from './core';

const AU_LOCATION_BIAS = {
  center: { lat: -25.0, lng: 133.0 },
  radius: 2000000,
};

export const getPlacePredictions = (search) =>
  new Promise((resolve) => {
    const { autocompleteService } = getApis();

    if (!autocompleteService) {
      return resolve([]);
    }
    
    autocompleteService.getPlacePredictions({
      input: search,
      locationBias: AU_LOCATION_BIAS,
      region: 'au',
    }, (result) => resolve(result));
  });

export const getPlaceDetails = (placeId) =>
  new Promise((resolve) => {
    const { placesService } = getApis();
    if (!placesService) {
      return resolve(null);
    }
    placesService.getDetails({ placeId }, (result) => resolve(result));
  }).then(googlePlace.parse);
